const TOOLTIP_VIEWPORT_PADDING = 24
const TOOLTIP_GAP = 6
const TOOLTIP_MAX_WIDTH = 320
const TOOLTIP_ARROW_HALF_WIDTH = 6
const TOOLTIP_ARROW_MIN_LEFT = 8
const TOOLTIP_ARROW_RIGHT_SPACE = 20

type TooltipAnchorRect = Pick<DOMRect, "bottom" | "height" | "left" | "right" | "top" | "width">

export interface RememberMeTooltipLayout {
  above: boolean
  arrowLeft: number
  left: number
  maxHeight: number
  top: number
  width: number
}

export const getRememberMeTooltipBounds = (viewportWidth: number, viewportHeight: number) => ({
  maxHeight: Math.max(0, viewportHeight - TOOLTIP_VIEWPORT_PADDING * 2),
  width: Math.max(0, Math.min(TOOLTIP_MAX_WIDTH, viewportWidth - TOOLTIP_VIEWPORT_PADDING * 2)),
})

export const getRememberMeTooltipLayout = (
  buttonRect: TooltipAnchorRect,
  measuredHeight: number,
  viewportWidth: number,
  viewportHeight: number
): RememberMeTooltipLayout => {
  const bounds = getRememberMeTooltipBounds(viewportWidth, viewportHeight)
  const availableAbove = Math.max(
    0,
    buttonRect.top - TOOLTIP_VIEWPORT_PADDING - TOOLTIP_GAP
  )
  const availableBelow = Math.max(
    0,
    viewportHeight - buttonRect.bottom - TOOLTIP_VIEWPORT_PADDING - TOOLTIP_GAP
  )
  const above =
    measuredHeight > 0 &&
    (measuredHeight <= availableAbove ||
      (measuredHeight > availableBelow && availableAbove > availableBelow))
  const maxHeight = Math.min(bounds.maxHeight, above ? availableAbove : availableBelow)
  const height = Math.min(measuredHeight, maxHeight)
  const top = above ? buttonRect.top - TOOLTIP_GAP - height : buttonRect.bottom + TOOLTIP_GAP
  const left = Math.min(
    Math.max(TOOLTIP_VIEWPORT_PADDING, buttonRect.right - bounds.width),
    Math.max(TOOLTIP_VIEWPORT_PADDING, viewportWidth - bounds.width - TOOLTIP_VIEWPORT_PADDING)
  )
  const arrowLeft = Math.min(
    Math.max(
      TOOLTIP_ARROW_MIN_LEFT,
      buttonRect.left + buttonRect.width / 2 - left - TOOLTIP_ARROW_HALF_WIDTH
    ),
    Math.max(0, bounds.width - TOOLTIP_ARROW_RIGHT_SPACE)
  )

  return { above, arrowLeft, left, maxHeight, top, width: bounds.width }
}
